// ── Sacred motif icons (used in modal section headers) ─────────
// Replaces the OS emoji rendering of 🕉 / 🔱 with proper styled glyphs
// so they look like deliberate iconography instead of phone emojis.

export function OmIcon({ size = 22, color = 'var(--saffron-dark)' }) {
  return (
    <span
      aria-hidden="true"
      style={{
        display: 'inline-block',
        fontFamily: "'Tiro Devanagari Hindi', 'Mukta', serif",
        fontSize: size,
        lineHeight: 1,
        color,
        fontWeight: 700,
        textShadow: '0 1px 0 rgba(255,180,90,0.20)',
        verticalAlign: 'middle',
      }}
    >ॐ</span>
  );
}

// Modern padlock — replaces the stale 🔒 / ✅ OS emojis. `open` renders the
// unlocked (raised shackle) variant. Inherits its colour from `color` so it
// blends into whatever pill / badge it sits in.
export function LockIcon({ size = 14, color = 'currentColor', open = false, style }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0, ...style }}
    >
      {/* shackle — raised & offset when open */}
      <path
        d={open ? 'M9 10V7a3.5 3.5 0 0 1 6.9-0.8' : 'M9 10V7a3.5 3.5 0 0 1 7 0v3'}
        stroke={color}
        strokeWidth="1.9"
        strokeLinecap="round"
        fill="none"
      />
      {/* body */}
      <rect x="5.5" y="10" width="13" height="9" rx="2.3" stroke={color} strokeWidth="1.9" fill="none" />
      {/* keyhole */}
      <circle cx="12" cy="13.6" r="1.35" fill={color} />
      <path d="M12 14.6 L12 16.4" stroke={color} strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

export function TrishulIcon({ size = 20, color = 'var(--saffron-dark)' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
      {/* central prong */}
      <path d="M16 4 L16 17" stroke={color} strokeWidth="2.2" strokeLinecap="round" />
      <path d="M14 4 L16 1 L18 4" stroke={color} strokeWidth="2" strokeLinejoin="round" fill={color} />
      {/* side prongs */}
      <path d="M9 6 L9 16 C9 17.5 10 18 11 18" stroke={color} strokeWidth="2" strokeLinecap="round" fill="none" />
      <path d="M7 7 L9 4 L11 7" stroke={color} strokeWidth="2" strokeLinejoin="round" fill={color} />
      <path d="M23 6 L23 16 C23 17.5 22 18 21 18" stroke={color} strokeWidth="2" strokeLinecap="round" fill="none" />
      <path d="M21 7 L23 4 L25 7" stroke={color} strokeWidth="2" strokeLinejoin="round" fill={color} />
      {/* crossbar + staff */}
      <path d="M7 18 L25 18" stroke={color} strokeWidth="2.4" strokeLinecap="round" />
      <path d="M16 18 L16 30" stroke={color} strokeWidth="2.4" strokeLinecap="round" />
    </svg>
  );
}
